import { Button } from '@fl/cmsch-fe-library';
import React, { FC, useCallback } from 'react';
interface Props {
  /** Association-role binding identifier. */
  userProfileAssociationRoleId: number;
  /** Callback invoked when the action is clicked. */
  onCellClick(userProfileAssociationRoleId: number): void;
}

/**
 * Renders a clickable association-management table action.
 *
 * @param props Cell identifier and click callback.
 * @returns Clickable association-management table action.
 */
export const DynamicContent: FC<Props> = ({
  userProfileAssociationRoleId,
  onCellClick
}) => {
  const handleCellClick = useCallback((): void => {
    onCellClick(userProfileAssociationRoleId);
  }, [onCellClick, userProfileAssociationRoleId]);
  return <Button icon="greenCheckCircleFilled" visuals="text" block onClick={handleCellClick} data-sentry-element="Button" data-sentry-component="DynamicContent" data-sentry-source-file="gen-dynamic-content.tsx" />;
};